export default __webpack_public_path__ + "static/char-s-17-jp-00381a9f7580725983ceb9ff30866b55.png";